import { FC } from 'react'

import styled from 'styled-components'
import { IncidentsReportMain } from './components'
import { IncidentsDashboard } from './components'
import { useTranslation } from 'react-i18next'
import { incidentReportsConstants } from 'locale/incidentReports'
import { NAMESPACE } from 'locale'
import { useSelector } from 'react-redux'
import { Home } from '@lmc/ts-common'
import useFeatureFlags from 'hooks/useFeatureFlags'
import { useNavigate, useParams } from 'react-router-dom'

type Props = {
  hasResidentsFilter?: boolean
  hasHomesFilter?: boolean
  hasSeverityFilter?: boolean
  hasOnClick?: boolean
  testId?: string
}

export const IncidentsReportMainScreen: FC<Props> = ({
  hasResidentsFilter,
  hasHomesFilter,
  hasSeverityFilter,
  hasOnClick = true,
  testId = 'incidents-report-main-screen'
}) => {
  const { t } = useTranslation(NAMESPACE.INCIDENT_REPORTS)

  const params = useParams()

  const isListView = params?.report === 'list'

  const isDashboardView = params?.report === 'dashboard'

  const home = useSelector(
    (state: { global: { home: Home } }) => state.global.home
  )

  const proEnabled = home?.features?.pro?.enabled

  const flags = useFeatureFlags({
    flagNames: [
      'incident_reports_list_view',
      'incidents_dashboard'
    ]
  })?.data

  const navigate = useNavigate()

  const incidentReportsListViewEnabled =
    flags.incident_reports_list_view.enabled

  const incidentsDashboardEnabled = flags.incidents_dashboard.enabled

  if (
    hasOnClick &&
    !incidentReportsListViewEnabled &&
    !incidentsDashboardEnabled
  ) {
    return null
  }

  if (hasOnClick && !proEnabled) {
    navigate('/')
  }

  return (
    <Wrapper data-testid={testId}>
      {isListView && incidentReportsListViewEnabled && (
        <IncidentsReportMain
          data-testid={`${testId}-list-view`}
          title={t(incidentReportsConstants.INCIDENTS_LIST_VIEW)}
          hasResidentsFilter={hasResidentsFilter}
          hasHomesFilter={hasHomesFilter}
          hasSeverityFilter={hasSeverityFilter}
          hasOnClick={hasOnClick}
        />
      )}
      {isDashboardView && incidentsDashboardEnabled && (
        <IncidentsDashboard
          data-testid={`${testId}-dashboard-view`}
          title={t(incidentReportsConstants.INCIDENTS_LIST_VIEW)}
          hasResidentsFilter={hasResidentsFilter}
          hasHomesFilter={hasHomesFilter}
          hasOnClick={hasOnClick}
        />
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  max-width: 1480px;
  padding: 24px 0 50px;
  margin: 0 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  ${({ theme }) => theme.mediaQueries?.tabletDown} {
    padding: 24px;
  }

  ${({ theme }) => theme.mediaQueries.mobileDown} {
    margin: 0;
  }
`
